
<div class="mb-md-3">
    <app-messaging></app-messaging>
    <router-outlet></router-outlet>
</div>
